import { API, graphqlOperation } from "aws-amplify";
import { GraphQLResult } from "@aws-amplify/api";
import { UpdateLLMConversationMutation } from "../API";
import { updateLLMConversation } from "../graphql/mutations";

export async function updateLLMConversationIntelligence(
  id: string,
  customerId: string|null,
  intelligence: string,

): Promise<GraphQLResult<UpdateLLMConversationMutation>> {

  // todo: if customer id, then update specific customer profile
  return API.graphql(
    graphqlOperation(updateLLMConversation, {
      input: {
        id: id,
        intelligence: intelligence,
      },
    })
  ) as Promise<GraphQLResult<UpdateLLMConversationMutation>>;
}
